import { CacheTypenames } from '@workbench-stack/core';


export const dataIdFromObject = {

    [CacheTypenames.Context]: (result) => CacheTypenames.Context,
    [CacheTypenames.Configuration]: (result) => CacheTypenames.Configuration,
    [CacheTypenames.Environment]: (result) => CacheTypenames.Environment,

    //Dialog
    [CacheTypenames.Dialog]: (result) => CacheTypenames.Dialog,
    [CacheTypenames.Detail]: (result) => `${CacheTypenames.Detail}:${result.inputName}`,

    //Notifications
    [CacheTypenames.Notifications]: (result) => CacheTypenames.Notifications,
    [CacheTypenames.Notification]: (result) => `${CacheTypenames.Notification}:${result.index}`,
    [CacheTypenames.Action]: (result) => `${CacheTypenames.Action}:${result.id}`,

    //Keybindings
    [CacheTypenames.Keybindings]: (result) => CacheTypenames.Keybindings,
    [CacheTypenames.KeybindingItem]: (result) => `${CacheTypenames.KeybindingItem}:${result.command}(${result.key})`,

    [CacheTypenames.EditorPart]: (result) => `${CacheTypenames.EditorPart}:${result.id}`,
    [CacheTypenames.EditorGroup]: (result) => `${CacheTypenames.EditorGroup}:${result.id}`,

    // EditorInput
    [CacheTypenames.DiffEditorInput]: (result) => `${result.editorId}/${result.resource}(${result.label})`,
    [CacheTypenames.ResourceEditorInput]: (result) => `${result.editorId}/${result.resource}(${result.label})`,
    [CacheTypenames.SideBySideEditorInput]: (result) => `${result.editorId}/${result.resource}(${result.label})`,
    [CacheTypenames.UntitledEditorInput]: (result) => `${result.editorId}/${result.resource}(${result.label})`,
    [CacheTypenames.DataUriEditorInput]: (result) => `${result.editorId}/${result.resource}(${result.label})`,

    //Statusbar
    [CacheTypenames.Statusbar]: (result) => CacheTypenames.Statusbar,

    //ContextMenu
    [CacheTypenames.ContextMenu]: (result) => CacheTypenames.ContextMenu,

    //QuickInputModel
    [CacheTypenames.QuickInputModel]: (result) => CacheTypenames.QuickInputModel,
    [CacheTypenames.QuickPickItem]: (result) => `${CacheTypenames.QuickPickItem}:${result.id}`,

    //Settings
    [CacheTypenames.SettingsGroup]: (result) => `${CacheTypenames.SettingsGroup}:${result.id}`,
    [CacheTypenames.SettingsSection]: (result) => CacheTypenames.SettingsSection,
    [CacheTypenames.Setting]: (result) => `${CacheTypenames.Setting}:${result.key}`,

    //GoToLineQuickAccess
    [CacheTypenames.GoToLineQuickAccess]: (result) => CacheTypenames.GoToLineQuickAccess,

    //Workspace
    [CacheTypenames.FolderConfigurationModel]: (result) => `${CacheTypenames.FolderWorkspace}:${result.id}`,
    [CacheTypenames.WorkspaceData]: (result) => `${CacheTypenames.WorkspaceData}:${result.id}`,
    [CacheTypenames.WorkspaceFolderData]: (result) => `${CacheTypenames.WorkspaceFolderData}:${result.name}`,
};

